import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import MSwitch from "../../../../components/ui/MSwitch";
import { useSalesModeContext } from "../../contexts";
import styles from "./SalesModeToggle.module.scss";

export const SalesModeToggle = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { orgId } = useParams();
    const { mode, toggleMode, isOrderingMode } = useSalesModeContext();

    const handleToggleMode = () => {
        toggleMode(() => {
            // 確認後跳轉到品項管理頁面
            navigate(`/sale/org/${orgId}/item`);
        });
    };

    return (
        <Box className={styles.modeToggleContainer}>
            <Box className={styles.modeToggleContent}>
                <Typography className={`${styles.modeLabel} ${isOrderingMode ? styles.active : ""}`} variant='body2'>
                    {/* TODO: i18n */}
                    {t("點餐模式")}
                </Typography>
                <MSwitch checked={mode === "exhibition"} onChange={handleToggleMode} size='small' />
                <Typography className={`${styles.modeLabel} ${!isOrderingMode ? styles.active : ""}`} variant='body2'>
                    {t("SALES.ExhibitionMode")}
                </Typography>
            </Box>
        </Box>
    );
};
